// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"e_pe"};